<template>
  <div>
    <h5>{{ !localUser.id ? 'Создание нового' : 'Редактирование' }} владельца</h5>
    <div>
      <div class="form-group">
        <label for="">Фамилия и инициалы</label>
        <input type="text" v-model="localUser.short_name" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Полное ФИО</label>
        <input type="text" v-model="localUser.full_name" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Догин к банкингу</label>
        <input type="text" v-model="localUser.banking_login" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Пароль к банкингу</label>
        <input type="text" v-model="localUser.banking_password" class="form-control">
      </div>
      <div class="form-group">
        <label for="">Комментарий</label>
        <input type="text" v-model="localUser.options.comment" class="form-control">
      </div>
      <div class="form-group">
        <label><input type="checkbox" v-model="localUser.is_active"> запись владельца активна</label>
      </div>
      <div class="mt-1 text-right">
        <LoadingButton
          title="Сохранить"
          :loading="loading"
          color="white"
          :onClick="() => saveRecord()"
          className="btn btn-success"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  props: ['user', 'callBackAction', 'closeDrawer'],
  components: {
    LoadingButton,
  },
  data() {
    return {
      localUser: {},
      loading: false,
    }
  },
  created() {
    if (this.user) {
      this.localUser = {...this.user};
      if (!this.localUser.options) {
        this.localUser.options = {comment: null};
      }
    }
  },
  methods: {
    async saveRecord() {
      this.loading = true;
      const {data} = await api.post('/cards/updateUser', {
        user: this.localUser,
      })
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно!')
        if (this.callBackAction) {
          this.callBackAction(data.user);
        }
        if (this.closeDrawer) {
          this.closeDrawer(null, true);
        }
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.loading = false;
    }
  }
}

</script>
